import { render, staticRenderFns } from "./DatosFigura.vue?vue&type=template&id=86f41d30&"
import script from "./DatosFigura.vue?vue&type=script&lang=js&"
export * from "./DatosFigura.vue?vue&type=script&lang=js&"
import style0 from "./DatosFigura.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports